<template>
  <div>
    <div class="card card-header list-group-item list-group-item-action active mb-3">
      <h4 class="mb-0">Cadastro de veículos da empresa</h4>
    </div>
    <div class="card">

      <div style="padding:15px;">
          <vs-table stripe
            :data="content">
            <template slot="header" >
              <h3>
                Registros
                <br>
                <small style="font-size:13px;">Clique no registro para expandir as informações</small>
              </h3>
            </template>
            <template slot="thead">

              <vs-th>
                Modelo
              </vs-th>
              <vs-th>
                Marca
              </vs-th>
              <vs-th>
                Ano modelo
              </vs-th>
              <vs-th>
                Ano fabricação
              </vs-th>
              <vs-th>
                Valor mercado
              </vs-th>
              <vs-th>
                Valor novo
              </vs-th>
              <vs-th>
                Valor IPVA
              </vs-th>
               <vs-th style="width:50px;">
               Aprovação
              </vs-th>
           </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td :data="fnConcat2(tr.modeloId,tr.marcaId)">
                  {{fnConcat2(tr.modeloId,tr.marcaId)}}
                </vs-td>
                <vs-td :data="fnConcat(tr.marcaId)">
                  {{fnConcat(tr.marcaId)}}
                </vs-td>
                <vs-td :data="tr.anoModelo">
                  {{tr.anoModelo}}
                </vs-td>
                <vs-td :data="tr.anoFabricacao">
                  {{tr.anoFabricacao}}
                </vs-td>
                <vs-td :data="tr.valorMercado">
                 R$ {{formataPrice(tr.valorMercado)}}
                </vs-td>
                <vs-td :data="tr.valorNovo">
                 R$ {{formataPrice(tr.valorNovo)}}
                </vs-td>
                <vs-td :data="tr.valorIpva">
                 R$ {{formataPrice(tr.valorIpva)}}
                </vs-td>

                <vs-td class="text-center">
                  <a
                  class="icone-editar"
                  data-editar
                  title="Benefícios"
                  v-if="!tr.aprovada"
                  @click="fnAprova(tr.etapaId)"
                  >
                    <i class="i-circled i-small i-light"
                    :class="'icon-flag-checkered1'"
                    :style="'background:#8fc4a5;'"
                    ></i>
                  </a>                  
                  <a
                  class="icone-editar"
                  data-editar
                  title="Benefícios"
                  v-else
                  >
                    <i class="i-circled i-small i-light"
                    :class="'icon-checkbox-checked'"
                    :style="'background:#ccc; color:#888'"
                    ></i>
                  </a>
                </vs-td>
                <template class="expand-user" slot="expand">
                  <p class="mb-1"><b> Valor do seguro</b>  R$ {{formataPrice(tr.valorSeguro)}}</p>
                  <p class="mb-1"><b> Manutenção mensal</b> R$ {{formataPrice(tr.valorManutencaoMensal)}}</p>
                  <b>Finalidade:</b>&nbsp;&nbsp;{{ tr.finalidade }}


                </template>                
              </vs-tr>
            </template>
          </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
  import { getSuccess,formatPrice,clientKey } from "@/global/utils";
  import 'vue2-datepicker/index.css';
  import 'vue2-datepicker/locale/pt-br';
  
  export default {
    data() {
      return {
        content:[],
        cadastro:{
        } ,
        marcas:{},
        modelos:{},
        incluindo:false,
        iconArea: 48 * 2,
        titulo:'',
        tipo:'',
        cadastroid:null
      }
    },

    mounted() {
      this.fnGetContratacao()
      this.fnGetmarcas()
      this.fnGetPeriodos()
    },
    methods: {
      async fnGetmarcas(){
        await this.$http.get('listamarcas/api/')
        .then(res=> {
          this.marcas = res.data
        })
        .catch(()=>{})
    },
    formatData(value) {
      return this.$moment(String(value)).format("DD/MM/YYYY");
    },
      async fnGetPeriodos(){
        await this.$http.get('listaperiodos/api/')
        .then(res=> {
          this.periodos = res.data
        })
        .catch(()=>{})
    },
    formataPrice(val){
      return formatPrice(val)
    },
      async fnAprova(etapaId) {
        const metodo = "put"
        let dados = {
          aprovada: true,
          tsAprovacao: this.$moment().format(),
          EtapaId: etapaId,
          contratacaoId: this.cadastroid
        }
        await this.$http[metodo]("/etapa_11/aprova/" +etapaId, dados)
          .then(() => {
            getSuccess();
             this.fnGetContratacao()
          })
          .catch(() => {});
      },    

      async fnGetContratacao() {
        await this.$http
          .get(`contratacao/codigo/${this.$route.params.codigoContrato}/etapa_11`)
          .then((res) => {
            this.cadastro.contratacaoId = res.data.contratacaoId;
            this.cadastroid = res.data.contratacaoId
            this.content=[]
            if(res.data.contratacoesEVO11 != null){
              var toString = JSON.stringify(res.data.contratacoesEVO11)
               var toJson = JSON.parse(toString)
              for(var i =0; i < toJson.length;i++){
                this.content.push(toJson[i])
              }
            }
          })
          .catch(() => {});
      },
      fnCancela(){
        this.incluindo = false;
        this.titulo = ''
        this.tipo =''

      },
      fnEdicao(val){
        if (val == 'Incluindo'){
          this.incluindo = true;
          this.titulo = 'Incluindo novo registro'
          this.tipo ='Inclusão'
        }
      },
      fnEditar(i){
       this.cadastro = this.content[i]
       this.cadastro.dataAquisicao = this.formatData(this.cadastro.dataAquisicao)
      this.listaModelos()
      },
      fnConcat(val){
        var item = this.marcas.filter((administracoes) => {
          return administracoes.marcaId ==val
        });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].titulo
    },
      fnConcatModelos(val){
        var item = this.marcas.filter((administracoes) => {
          return administracoes.marcaId ==val
        });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].tabelaMarcasModelos
    },
      fnConcat2(val,val2){
        var modelos = this.fnConcatModelos(val2)
        console.log(modelos)
        var item = modelos.filter((data) => {
          return data.modeloId ==val
        });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        return toJson[0].titulo
    },
    listaModelos(){
         var item = this.marcas.filter((data) => {
          return data.marcaId == this.cadastro.marcaId
        });
        var toString = JSON.stringify(item)
        var toJson = JSON.parse(toString)
        this.modelos =toJson[0].tabelaMarcasModelos
     
    },
    convertToken(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return JSON.parse(jsonPayload);
        },
    async fnDeletar(val) {

        var token = localStorage.getItem(clientKey)
        var dataToken = this.convertToken(token)
      await this.$http.delete(`/etapa_11/${val}/${dataToken.ClienteId}`)
        .then(() => {
          let i = this.content.map(item => item.etapaId).indexOf(val) 
          this.content.splice(i, 1)
          getSuccess();
        })
        .catch(() => {});
    },

    },
  }
</script>

<style lang="scss" scoped>
.card-header {
  h4 {
    color: #fff;
    text-align: center;
  }
}
.expand-user{
  width: 100% !important;
}
.tr-expand td .content-tr-expand, .tr-expand td .tr-expand--close{
  display: block !important;
}
</style>